import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RFQs } from '../Redux/Mycart/action';
import { storage } from '../Config/Storage';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  Pagination,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Link } from 'react-router-dom';
import ButtonBox from '../Components/Button';
import Loader from '../Components/Loader';
import Empty from '../Components/Empty';
import Styles from '../Config/Styles';
import Tablehead from '../Components/TableHead';

const Rfq = () => {
  const { rfq } = useSelector((state) => state?.CartData) || [];
  const dispatch = useDispatch();
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    dispatch(RFQs({ id: storage.fetch.phone(), page: page }, setLoading))

  }, [page])
  useEffect(() => {
    setPages(Math.ceil(parseInt(rfq?.total) / 5))
  }, [rfq, pages, page])

  const handleDownload = (fileUrl) => {
    // Trigger download
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileUrl.split("/").pop(); // Extract file name from URL
    link.click();
  };

  const handlePageChange = (event, value) => {
    setPage(value)
  }


  return (
    <>
      <Loader open={loading} />
      {!rfq?.data?.length ? <Empty name={"RFQ"} />
        :
        <> <Table>
          <Tablehead data={["File", "Action"]} />
          <TableBody>
            {rfq?.data?.map((file, index) => (
              <TableRow key={index}>
                <TableCell>{file.name}</TableCell>
                <TableCell>
                  <Link
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={() => handleDownload(`https://api-dev.tabta.net/assets/${file.file}?key=system-small-cover`)}
                  >
                    Download
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
          <Box sx={Styles.order.pagi}>
            <Pagination
              page={page}
              count={pages}
              onChange={handlePageChange}
            />
          </Box>
        </>
      }
    </>
  )
}

export default Rfq